<template lang="pug">
  e-chart(
    :header="`${documentTitle}`"
    :options="chartGarbageHandlingDynamicOptions"
    :series="chartGarbageHandlingDynamicSeries"
    chartId="garbageHandlingDynamic"
    :chartRedirectParams="chartRedirectParams"
      :chartLoading="chartLoading"
      :chartError="chartError"
  )
    template(slot="chartHeader")
      .default-select.part-1-from-1
        e-select(
        class="dropdown-btn"
        tabView="tab1"
        :model="fields.garbageHandlingDynamic"
        name="viewMode"
        :options="chartViewModeOptions"
        )

      .default-select.part-1-from-4
        div.view-panel
          button.view-panel__button.view-chart(
            :class="garbageHandlingDynamicChartType==='line' ? 'active' : ''"
            @click="setGarbageHandlingDynamicChartType('line')"
          )
          button.view-panel__button.view-chart-col(
            :class="garbageHandlingDynamicChartType==='column' ? 'active' : ''"
            @click="setGarbageHandlingDynamicChartType('column')"
          )

</template>
<script>
  import chartsMixin from '../mixins/charts-mixin.js'
  import {grey} from '../utils/chartOptionsData'

  export default {
    mixins: [chartsMixin],
    data () {
      return {
        garbageHandlingDynamicChartType: null
      }
    },
    created () {
      this.chartGarbageHandlingDynamicOptions = this.getCurrentChartOptions
      this.garbageHandlingDynamicChartType = this.chartGarbageHandlingDynamicOptions.chart.type
      this.fetchData()
    },
    watch: {
      'fields.garbageHandlingDynamic.viewMode': {
        handler: function(v) {
          this.viewMode = v
          this.fetchData()
        }
      }
    },
    computed: {
      viewMode: {
        get: function () {
          return this.$store.getters.charts.garbageHandlingDynamic.viewMode
        },
        set: function (newValue) {
          this.$store.commit('charts', {garbageHandlingDynamic: {viewMode: newValue}})
        },
      },
      getCurrentChartOptions () {
        return this.getChartOptions('garbageHandlingDynamic')
      }
    },
    methods: {
      buildEndpoint () {
        return this.getEndpoint()({
          query: {
            type: 'dynamic',
            viewMode: this.viewMode
          }
        })
      },
      setGarbageHandlingDynamicChartType (type) {
        this.chartGarbageHandlingDynamicOptions.chart.type = type
        this.garbageHandlingDynamicChartType = type
      },
      fetchData () {
        this.fetchChartData().then(r => {
          this.chartGarbageHandlingDynamicSeries = this.transform(r)
        })
      },
      transform (response) {
        let series = []
        if (response.data && response.data.data) {
          try {
            series = response.data.data.series
            for (let i = 0; i < series.length; i++) {
              for (let j = 0; j < series[i].data.length; j++) {
                if (series[i].data[j] !== null) {
                  if(series[i].name && series[i].name === 'Не распределено'){
                    series[i].color = grey
                  }
                  series[i].data[j] = +series[i].data[j]
                }
              }
            }
            this.chartGarbageHandlingDynamicOptions.xAxis.categories = response.data.data.years
          } catch (e) {
            this.chartError = 'Ошибка обработки данных: ' + e.toString()
          }
        }
        return series
      }
    }
  }
</script>
